import { isProd } from "../env/env"

const bucketUrlUat = "https://d1uqkel1xiyefa.cloudfront.net/"
const bucketUrlProd = "https://d7t9aukg0nsw0.cloudfront.net/"
// const bucketUrlUat = "https://empapp-public-s3-bucket.s3.ap-south-1.amazonaws.com/"
// const bucketUrlProd = "https://empapp-public-s3-bucket.s3.ap-south-1.amazonaws.com/"

export const bucketUrl = isProd ? bucketUrlProd : bucketUrlUat